import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Badge, Button, Alert } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Paginator from 'Components/UI/Paginator';
import NotificationService from 'Services/NotificationService';
import { assignWindowLocation } from 'Utils/Helpers';
import useQuery from 'Utils/hooks/useQuery';
import UrgencyShapedIcon from 'Components/UI/UrgencyIcon';
import XssHTMLSanitizer from 'HOC/XssHTMLSanitizer';

const Home = () => {
    const [activePage, setActivePage] = useState(1);
    const [adminNotifications, setAdminNotifications] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const globalTotalPage = 10;
    const history = useHistory();
    const query = useQuery();

    useEffect(() => {
        const page = query.get('page');
        let currentPage = 1;
        if (page) currentPage = 2;
        setActivePage(currentPage);
        const loadData = async () => {
            await loadFreshNotifications(globalTotalPage, page);
        };
        loadData();
    }, [query]);

    const loadFreshNotifications = async (totalPage, page = 1) => {
        try {
            const result = await NotificationService.getFreshNotifications(totalPage, page);
            if (result.status === 200) {
                setNotifications(result.data.data);
                setNotificationsCount(result.data.count);
            }
            const notificationsResultByAdmins = await NotificationService.getFreshAdminNotification();
            if (notificationsResultByAdmins.status === 200) {
                setAdminNotifications(notificationsResultByAdmins.data);
            }
        } catch (Exception) {}
    };

    const removeNotification = async (notificationId) => {
        try {
            const result = await NotificationService.setAsSeen(notificationId);
            if (result.status === 200) {
                await loadFreshNotifications(globalTotalPage, activePage);
            }
        } catch (Exception) {}
    };

    const goToUrl = async (notification) => {
        await removeNotification(notification.notificationId);
        assignWindowLocation(notification.actionUrl);
    };

    const handlePageChange = (activePage) => {
        history.push(activePage > 1 ? `?page=${activePage}` : '/');
    };

    return (
        <React.Fragment>
            <Container>
                <div className="pt-2"></div>
                <Row>
                    <Col md={{ order: 'last', span: 6 }} className="border-md-left">
                        <h4>Alertes</h4>
                        {adminNotifications &&
                            (adminNotifications.length > 0 ? (
                                <>
                                    {adminNotifications.map((notification, key) => (
                                        <Card key={key} className="mt-3 position-relative">
                                            <UrgencyShapedIcon
                                                size="sm"
                                                status={notification.urgency}
                                                showNormalIcon
                                                circle
                                                borderColor="#fff"
                                                styles={{ position: 'absolute', top: '-10px', left: '-10px' }}
                                            />
                                            <Card.Header
                                                as="h5"
                                                className="d-flex justify-content-between align-middle"
                                            >
                                                <div className="align-middle">
                                                    <Badge
                                                        variant="dark"
                                                        className="mr-2 align-middle"
                                                        style={{
                                                            fontSize: '8pt',
                                                            fontWeight: 'normal',
                                                            padding: '3pt 7pt',
                                                        }}
                                                    >
                                                        {dayjs(notification.datetime).format('HH:mm DD/MM/YY')}
                                                    </Badge>
                                                    <Badge
                                                        variant="success"
                                                        className="mr-2 align-middle"
                                                        style={{
                                                            fontSize: '8pt',
                                                            fontWeight: 'normal',
                                                            padding: '3pt 7pt',
                                                        }}
                                                    >
                                                        {notification.eventHandle}
                                                    </Badge>
                                                    {notification.title}
                                                </div>
                                                {notification.urgency !== 'Critical' && (
                                                    <AiOutlineCloseCircle
                                                        className="del_notification-button"
                                                        onClick={() => {
                                                            removeNotification(notification.notificationId);
                                                        }}
                                                    ></AiOutlineCloseCircle>
                                                )}
                                            </Card.Header>
                                            <Card.Body>
                                                {/* <Card.Text>{notification.content}</Card.Text> */}
                                                {/* <Card.Text dangerouslySetInnerHTML={{ __html: notification.content }} /> */}
                                                <XssHTMLSanitizer
                                                    targetComponent={Card.Text}
                                                    htmlData={notification.content}
                                                />
                                                {notification.actionName && (
                                                    <Button
                                                        className="float-right validation_notification_button"
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => goToUrl(notification)}
                                                    >
                                                        {notification.actionName}
                                                    </Button>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </>
                            ) : (
                                <Alert variant="secondary">Vous avez zéro alerte pour le moment.</Alert>
                            ))}
                    </Col>
                    <Col md={{ order: 'first', span: 6 }}>
                        <div className="d-flex flex-wrap justify-content-between">
                            <h4>Notifications</h4>
                            <Paginator
                                defaultPage={activePage}
                                maxPages={Math.ceil(notificationsCount / globalTotalPage)}
                                callback={(activePage) => handlePageChange(activePage)}
                            />
                        </div>
                        {notifications &&
                            (notifications.length > 0 ? (
                                <>
                                    {notifications.map((notification, key) => (
                                        <Card key={key} className="mt-3">
                                            <Card.Header
                                                as="h5"
                                                className="d-flex justify-content-between align-middle"
                                            >
                                                <div className="align-middle">
                                                    <Badge
                                                        variant="dark"
                                                        className="mr-2 align-middle"
                                                        style={{
                                                            fontSize: '8pt',
                                                            fontWeight: 'normal',
                                                            padding: '3pt 7pt',
                                                        }}
                                                    >
                                                        {dayjs(notification.datetime).format('HH:mm DD/MM/YY')}
                                                    </Badge>
                                                    <Badge
                                                        variant="success"
                                                        className="mr-2 align-middle"
                                                        style={{
                                                            fontSize: '8pt',
                                                            fontWeight: 'normal',
                                                            padding: '3pt 7pt',
                                                        }}
                                                    >
                                                        {notification.eventHandle}
                                                    </Badge>
                                                    {notification.title}
                                                </div>
                                                <AiOutlineCloseCircle
                                                    className="del_notification-button"
                                                    onClick={() => {
                                                        removeNotification(notification.notificationId);
                                                    }}
                                                ></AiOutlineCloseCircle>
                                            </Card.Header>
                                            <Card.Body>
                                                {/* <Card.Text>{notification.content}</Card.Text> */}
                                                {/* <Card.Text dangerouslySetInnerHTML={{ __html: notification.content }} /> */}
                                                <XssHTMLSanitizer
                                                    targetComponent={Card.Text}
                                                    htmlData={notification.content}
                                                />
                                                {notification.actionName && (
                                                    <Button
                                                        className="float-right validation_notification_button"
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => goToUrl(notification)}
                                                    >
                                                        {notification.actionName}
                                                    </Button>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    ))}
                                </>
                            ) : (
                                <Alert variant="secondary">Vous avez zéro notification pour le moment.</Alert>
                            ))}
                    </Col>
                </Row>
            </Container>
        </React.Fragment>
    );
};

export default Home;
